/**
 * Y2K stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const y2kStickersPack: ToilePack = {
    slug: 'y2k-stickers',
    category: 'sticker',
    name: 'Y2K stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'clip', label: 'Butterfly clip', subject: 'a glittery butterfly hair clip'},
        {key: 'phone', label: 'Flip phone', subject: 'a pink flip phone with a charm'},
        {key: 'star', label: 'Slogan star', subject: 'a chunky star lettered "CUTE" in bubble type'},
    ],
    styles: [
        {key: 'holo', label: 'Holographic', style: 'holographic sticker, iridescent rainbow sheen across the surface, glossy', palette: 'Iridescent silver shifting through pink, cyan and gold', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'kawaii', label: 'Kawaii', style: 'kawaii sticker illustration, rounded shapes, tiny smiling faces, soft thick outlines', palette: 'Pastel pink, mint, lilac and cream with dark outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'vinyl', label: 'Vinyl', style: 'glossy vinyl sticker, clean vector shapes, bold flat colour, a small highlight', palette: 'Bright flat colour with a white highlight', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
    ],
    directions: ['a disco ball instead', 'a whole sticker sheet', 'in pastel colors'],
    directionHint: 'try: a disco ball instead',
    seo: {
        title: 'Y2K Stickers: Butterfly Clip, Flip Phone, Star',
        metaDescription: 'Nine Y2K stickers — a butterfly hair clip, a flip phone, a lettered slogan star — in holographic, kawaii, and vinyl styles.',
        h1: 'Y2K stickers: butterfly clip, flip phone, slogan star',
        tagline: 'Nine stickers, three 2000s icons, three styles each.',
        intro: "A glittery butterfly hair clip, a pink flip phone with a charm, and a chunky star lettered 'CUTE' in bubble type — three Y2K stickers, die-cut and ready to print. Each rendered holographic, kawaii, and glossy vinyl. Ask for a different slogan, a disco-ball scene, or a low-rise-jeans composition, and the same three styles carry it.",
        useCases: [
            'a laptop or water bottle',
            'a phone case sticker sheet',
            'a planner or scrapbook page',
            'a Y2K-themed party favour',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine Y2K stickers — a butterfly hair clip, a flip phone, and a slogan star — in holographic, kawaii, and glossy vinyl finishes.'},
            {q: 'Can I get a different slogan or scene?', a: 'Yes — the direction field takes any variation, including a different slogan, a disco-ball scene, or a low-rise-jeans composition.'},
            {q: 'What does the holographic finish print as?', a: 'The holographic design is an illustrated iridescent sheen — print it on holographic vinyl stock for the real shifting effect, or on plain matte stock for a flat colourful version.'},
            {q: 'Does the flip phone show a real brand?', a: "No — it's a generic flip-phone silhouette, not a licensed brand or model."},
        ],
    },
}
